import { Pressable as NbPressable } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const Pressable = NbPressable;

export default addWithConfig(Pressable);
